import { render } from "./ApartmentSelector.vue?vue&type=template&id=182d23ac&scoped=true"
import script from "./ApartmentSelector.vue?vue&type=script&lang=js"
export * from "./ApartmentSelector.vue?vue&type=script&lang=js"

import "./ApartmentSelector.vue?vue&type=style&index=0&id=182d23ac&scoped=true&lang=scss"

import exportComponent from "/Users/alexanderwesselburg/Projekte/MyPortal/fewo-in-ahrenshoop_v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-182d23ac"]])

export default __exports__